import { getForcedModeForHostname, normalizeHostname } from "./modeRouting";

export function getModeFromPath(pathname = "/", hostname = "") {
  const normalizedPath = String(pathname || "/").toLowerCase();
  const normalizedHost = normalizeHostname(hostname);
  const forcedMode = getForcedModeForHostname(normalizedHost);

  if (forcedMode) {
    return forcedMode;
  }

  if (normalizedPath.startsWith("/teacher")) return "campus";
  if (normalizedPath.startsWith("/parent")) return "campus";
  if (normalizedPath.startsWith("/globaladmin")) return "admin";
  if (normalizedPath.startsWith("/workspace")) return "edu";
  if (normalizedPath.startsWith("/classroom")) return "edu";
  if (
    normalizedPath.startsWith("/devices") ||
    normalizedPath.startsWith("/studentdevice") ||
    normalizedPath.startsWith("/studentdevices")
  ) return "devices";
  if (normalizedPath.startsWith("/admin")) return "admin";
  if (normalizedPath.startsWith("/campus")) return "campus";
  if (normalizedPath.startsWith("/edu")) return "edu";
  if (normalizedPath.startsWith("/pages")) return "pages";
  if (normalizedPath.startsWith("/tables")) return "tables";

  return "edu";
}
